import React, { useState, useEffect, useRef } from "react";
import { useAuth } from "../AuthContext";
import axios from "axios";
import "../styles/UserEditModal.css";
import AddLog from "./AddLog"; // ✅ 로그 저장 함수 가져오기

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL; 

const UserEditModal = ({ selectedUser, plist, glist, onClose, onSave, onUserAdded }) => {    
    const { user } = useAuth();
    const [editedUser, setEditedUser] = useState(selectedUser);
    //const [PListData, setPListData] = useState(glist);
    //const [GListData, setGListData] = useState(plist);
    // 초기 전화번호 분할
    const [phone1, setPhone1] = useState("");
    const [phone2, setPhone2] = useState("");
    const [phone3, setPhone3] = useState("");
    // 초기 이메일 분할
    const [email1, setEmail1] = useState("");
    const [email2, setEmail2] = useState("");
    //const [plist, setPlist] = useState([]);
    //const [glist, setGlist] = useState([]);

    const hasRun = useRef(false);


    useEffect(() => {

        if (hasRun.current) return; // 이미 실행되었으면 종료

        hasRun.current = true; // 첫 실행 후 플래그 설정

        //if (user.userType === "S") {
        //    getPartnerCode();
        //    getGovernmentCode();            
        //}
    }, []); // userType 또는 user.userType이 변경될 때 실행

    /*
    // 파트너 코드 리스트 가져오기
    const getPartnerCode = async () => {

        try {
            const response = await fetch(`${API_BASE_URL}/api/Partner/get-list`);
            const data = await response.json();

            if (response.ok) {
                setPlist(data.plist);
                //console.log(data.plist);
            } else {
                alert(data.message || "조회 실패");
            }

        } catch (error) {
            alert("파트너 리스트 조회 중 오류가 발생했습니다.");
        }
    };

    // 파트너 코드 리스트 가져오기
    const getGovernmentCode = async () => {

        try {
            const response = await fetch(`${API_BASE_URL}/api/Government/get-list`);
            const data = await response.json();

            if (response.ok) {
                setGlist(data.glist);
                //console.log(data.glist);
            } else {
                alert(data.message || "조회 실패");
            }

        } catch (error) {
            alert("관공서 리스트 조회 중 오류가 발생했습니다.");
        }
    };
    */

    // 카카오 주소 검색
    const handleSearchAddress = () => {
        new window.daum.Postcode({
            oncomplete: (data) => {
                // 주소 값을 상태에 저장
                setEditedUser((prev) => ({ ...prev, address1: data.address }));
            },
            width: 500, // 창 너비
            height: 600, // 창 높이
        }).open({
            left: (window.screen.width / 2) - 250,  // 중앙 정렬 (화면 너비 기준)
            top: (window.screen.height / 2) - 300   // 중앙 정렬 (화면 높이 기준)
        });
    };

    const handleDelete = async () => {  
        const DeleteUserId = editedUser.userId;

        if (!DeleteUserId) {
            alert("사용자 ID가 없습니다.");
            return;
        }

        if (window.confirm(`${DeleteUserId} 사용자를 정말 삭제하시겠습니까?`)) {
            // 삭제 로직 추가
            try {
               
                const response = await axios.delete(`${API_BASE_URL}/api/Account/delete-user?userId=${DeleteUserId}`);

                if (response.status === 204) {

                    await AddLog(user.userId, "", DeleteUserId, "5-4");

                    alert("사용자가 삭제되었습니다.");
                    //onSave();  // 리스트 갱신을 요청하는 콜백 호출
                    onUserAdded();
                    onClose();
                }
            } catch (error) {
                if (error.response && error.response.status === 404) {
                    alert("삭제 할 사용자를 찾을 수 없습니다.");
                } else {
                    alert("삭제 중 오류발생.");
                }
            }            
        }
    };

    const handleResetPassword = async (field, value) => {    
        if (window.confirm(`${editedUser.userId} 사용자의 비밀번호 초기화를 진행하겠습니까?`)) {
            // 비밀번호 초기화 로직 추가
            
            field = "비밀번호";
            value = "$2a$11$NAE2MpRB1a3KIQAL1Eq3M.K61LnDMeedB0wp.M44NVgSz.qF9caMe";
            try {
                const response = await axios.post(`${API_BASE_URL}/api/Account/update-field`, {
                    userId: editedUser.userId,
                    fieldName: field,
                    newValue: value,
                });

                if (response.status === 200) {

                    await AddLog(user.userId, "", editedUser.userId, "5-3");

                    alert("비밀번호가 '111111'으로 초기화되었습니다.");

                } else {
                    alert("비밀번호 초기화 실패2");
                }
            } catch (error) {
                console.error("비밀번호 초기화 중 오류 발생:", error);
                alert("비밀번호 초기화 실패");
            }
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;

        // editedUser 상태 업데이트
        setEditedUser((prev) => {
            let updatedUser = { ...prev, [name]: value };

            // 파트너 코드 변경 시, 관련된 관공서 코드 자동 설정
            if (name === "partnerCode") {
                const selectedPartner = plist.find(p => p.partnerCode === value);
                updatedUser.governmentCode = selectedPartner ? selectedPartner.governmentCode || "" : "";
            }
            if (name === "userType") {
                updatedUser.partnerCode = "";
                updatedUser.governmentCode = "";
            }

            return updatedUser;
        });
    };

    const handleSave = async () => { // 'async' 추가

        if (!editedUser.userDate.trim()) {
            alert("등록일자를 입력 해주세요!");
            setTimeout(() => {
                document.getElementsByName("userDate")[0].focus();
            }, 0);
            return;
        }
        else if (!editedUser.name.trim()) {
            alert("이름을 입력 해주세요!");
            setTimeout(() => {
                document.getElementsByName("name")[0].focus();
            }, 0);
            return;
        }
        else if (!phone1.trim() || !phone2.trim() || !phone3.trim()) {
            alert("전화번호를 입력 해주세요!");
            setTimeout(() => {
                if (phone1.trim() === "") { document.getElementsByName("phone1")[0].focus(); }
                else if (phone2.trim() === "") { document.getElementsByName("phone2")[0].focus(); }
                else if (phone3.trim() === "") { document.getElementsByName("phone3")[0].focus(); }
            }, 0);
            return;
        }
        else if (!email1.trim() || !email2.trim()) {
            alert("이메일 주소를 입력 해주세요!");
            setTimeout(() => {
                if (email1.trim() === "") { document.getElementsByName("email1")[0].focus(); }
                else if (email2.trim() === "") { document.getElementsByName("email2")[0].focus(); }
            }, 0);
            return;
        }
        else if (!editedUser.address1.trim()) {
            alert("주소검색으로 기본주소를 입력 해주세요!");
            setTimeout(() => {
                document.getElementsByName("addressbt")[0].focus();
            }, 0);
            return;
        }
        else if (!editedUser.address2.trim()) {
            alert("나머지 주소를 입력 해주세요!");
            setTimeout(() => {
                document.getElementsByName("address2")[0].focus();
            }, 0);
            return;
        }

        if (editedUser.userType === 'S') {
            editedUser.partnerCode = "";
            editedUser.governmentCode = "";
        }
        if (editedUser.userType === 'G') {
            editedUser.partnerCode = "";            
        }

        editedUser.name = editedUser.name.trim();
        editedUser.email = editedUser.email.trim();
        setEmail1(email1?.trim()); // @ 앞부분
        setEmail2(email2?.trim()); // @ 뒷부분           
        editedUser.address2 = editedUser.address2.trim();
        editedUser.partnerCode = editedUser.partnerCode.trim();
        editedUser.governmentCode = editedUser.governmentCode.trim();

        const updateUser = {
            UserId: editedUser.userId,
            UserDate: editedUser.userDate, // YYYY-MM-DD
            UserType: editedUser.userType,
            //Password: "$2a$11$NAE2MpRB1a3KIQAL1Eq3M.K61LnDMeedB0wp.M44NVgSz.qF9caMe",
            Name: editedUser.name,
            Phone: `${phone1}-${phone2}-${phone3}`, // 백엔드와 일치
            Email: `${email1.trim()}@${email2.trim()}`,
            Address1: editedUser.address1,
            Address2: editedUser.address2,
            Active: editedUser.isActive, // 백엔드와 일치
            PartnerCode: editedUser.partnerCode, // 백엔드와 대소문자 일치
            GovernmentCode: editedUser.governmentCode, // 백엔드와 대소문자 일치
        };

        //console.log("사용자 수정 정보:", JSON.stringify(updateUser, null, 2));
        //alert(updateUser.UserId);

        try {

            const response = await fetch(`${API_BASE_URL}/api/Account/update-user`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(updateUser),
            });

            const data = await response.json();
            if (response.ok) {

                await AddLog(user.userId, "", editedUser.userId, "5-2");

                alert("사용자 정보 변경이 완료되었습니다.");
                
                onSave(editedUser);
                onClose();
            } else {
                alert("사용자 정보 변경이 실패했습니다: " + data.message);
                //console.log("응답 상태 코드:", response.status);
                //console.log("서버 응답 데이터:", data);
            }

        } catch (error) {
            //console.error("오류:", error);
            alert("사용자 정보 변경 중 오류가 발생했습니다.");
        }

        onClose(); // 팝업 닫기
    };

    // `editedUser.phone` 값이 변경될 때 phone1, phone2, phone3 값 설정
    useEffect(() => {
        if (editedUser.phone) {
            const phoneParts = editedUser.phone.split("-");
            setPhone1(phoneParts[0] || "");
            setPhone2(phoneParts[1] || "");
            setPhone3(phoneParts[2] || "");
        }
    }, [editedUser.phone]);
    // `editedUser.email` 값이 변경될 때 email1, email2 값 설정
    useEffect(() => {
        if (editedUser.email) {
            const emailParts = editedUser.email.split("@");
            setEmail1(emailParts[0].trim() || ""); // @ 앞부분
            setEmail2(emailParts[1].trim() || ""); // @ 뒷부분
        }
    }, [editedUser.email]);

    // 전화번호 변경 시 전체 phone 값을 업데이트하는 함수
    const handlePhoneChange = (e) => {
        const { name, value } = e.target;
        const numericValue = value.replace(/[^0-9]/g, ""); // 숫자만 허용

        if (name === "phone1") setPhone1(numericValue);
        else if (name === "phone2") setPhone2(numericValue);
        else if (name === "phone3") setPhone3(numericValue);

        // 변경된 전화번호를 "010-1234-5678" 형식으로 업데이트
        const newPhone = `${name === "phone1" ? numericValue : phone1}-${name === "phone2" ? numericValue : phone2}-${name === "phone3" ? numericValue : phone3}`;
        handleChange({ target: { name: "phone", value: newPhone } });
    };
    // 이메일 변경 시 전체 email 값을 업데이트하는 함수
    const handleEmailChange = (e) => {
        const { name, value } = e.target;

        if (name === "email1") setEmail1(value);
        else if (name === "email2") setEmail2(value);

        // 변경된 이메일을 "id@domain.com" 형식으로 업데이트
        const newEmail = `${name === "email1" ? value : email1}@${name === "email2" ? value : email2}`;
        handleChange({ target: { name: "email", value: newEmail } });
    };

    return (
        <div className="addmodal-overlay">
            <div className="addmodal-content">

                {/* 모달 헤더 */}
                <div className="addmodal-header">
                    <h2>{editedUser.snum}.{editedUser.userId} Update</h2>
                    <button className="addmodal-close-btn" onClick={onClose}><i className="fa fa-times-circle"></i></button>
                </div>

                {user.userType === "S" && (
                    <div className="addform-group">
                        <label>등록일자</label>
                        <div className="addinput-group">
                            <input
                                type="date"
                                name="userDate"
                                value={editedUser.userDate}
                                onChange={(e) => setEditedUser({ ...editedUser, userDate: e.target.value })}
                            //onChange={handleChange}
                            //style={{ fontWeight: "bold" }} // 글자를 두껍게 설정
                            />
                        </div>
                    </div>
                )}

                {user.userType === "S" && (
                    <div className="addform-group">
                        <label>회원구분</label>
                        <div className="addinput-group">
                            <select name="userType" value={editedUser.userType} onChange={handleChange}  >
                                <option value="U">사용자</option>
                                <option value="P">파트너</option>
                                <option value="G">관공서</option>
                                <option value="S">빛담관리자</option>
                            </select>
                        </div>
                    </div>
                )}

                <div className="addform-group">
                    <label>이름</label>
                    <div className="addinput-group">
                        <input type="text" maxLength="18" name="name" value={editedUser.name} onChange={handleChange} />
                    </div>
                </div>

                <div className="addform-group">
                    <label>전화번호</label>
                    <div className="addphone-group">
                        <input
                            type="text"
                            maxLength="3"
                            name="phone1"
                            value={phone1}
                            onChange={handlePhoneChange}
                        />
                        <span>-</span>
                        <input
                            type="text"
                            maxLength="4"
                            name="phone2"
                            value={phone2}
                            onChange={handlePhoneChange}
                        />
                        <span>-</span>
                        <input
                            type="text"
                            maxLength="4"
                            name="phone3"
                            value={phone3}
                            onChange={handlePhoneChange}
                        />
                    </div>
                </div>

                <div className="addform-group">
                    <label>이메일</label>
                    <div className="addemail-group">
                        <input
                            type="text"
                            maxLength="20"
                            name="email1"
                            value={email1}
                            onChange={handleEmailChange}
                        />
                        <span>@</span>
                        <input
                            type="text"
                            maxLength="20"
                            name="email2"
                            value={email2}
                            onChange={handleEmailChange}
                        />                        
                    </div>
                </div>

                <div className="addform-group">
                    <label>주소1</label>
                    <div className="addinput-group">
                        <input type="text" name="address1" readOnly value={editedUser.address1 || ""} onChange={handleChange} />
                        <button name="addressbt" className="addsearch-btn" onClick={handleSearchAddress}><i className="fa fa-search"></i></button>
                    </div>
                </div>

                <div className="addform-group">
                    <label>주소2</label>
                    <div className="addinput-group">
                        <input type="text" maxLength="40" name="address2" value={editedUser.address2} onChange={handleChange} />
                    </div>
                </div>

                {user.userType === "S" && (
                    <div className="addform-group">
                        <label>활성화</label>
                        <div className="addinput-group">
                            <select name="isActive" value={editedUser.isActive} onChange={handleChange}>
                                <option value="T">활성화</option>
                                <option value="F">비활성화</option>
                            </select>
                        </div>
                    </div>
                )}

                
                {user.userType === "S" && !(editedUser.userType === "S" || editedUser.userType === "G") && (
                    <div className="addform-group">
                        <label>파트너 코드</label> 
                        <div className="addinput-group">
                            <select name="partnerCode" value={editedUser.partnerCode} onChange={handleChange}>
                                <option value="">파트너를 선택하세요</option> {/* 기본값 */}
                                {plist.map((partner) => (
                                    <option key={partner.snum} value={partner.partnerCode}>
                                        {partner.snum}, {partner.partnerCode} : {partner.partnerName}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>
                )}

                {user.userType === "S" && !(editedUser.userType === "S") && (
                    <div className="addform-group">
                        <label>관공서 코드</label>
                        <div className="addinput-group">
                            <select
                                name="governmentCode"
                                value={editedUser.governmentCode}
                                onChange={handleChange}
                                disabled={editedUser.userType === "U" || editedUser.userType === "P"} // U 또는 P일 때 편집 불가
                            >
                                <option value="">관공서를 선택하세요</option> {/* 기본값 */}
                                {glist.map((government) => (
                                    <option key={government.snum} value={government.governmentCode}>
                                        {government.snum}, {government.governmentCode} : {government.governmentName}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>
                )}

                

              
                {/* 업데이트 버튼 */}
                <div className="button-group">     
                    {user.userType === "S" && (
                        <>
                            <button className="delete-btn" onClick={handleDelete} style={{ backgroundColor: "red", color: "white" }}><i className="fa fa-trash"></i></button>
                            <button className="reset-btn" onClick={handleResetPassword} style={{ backgroundColor: "pink", color: "black" }}><i className="fa fa-unlock"></i></button>
                        </>
                    )}
                    <button className="addsave-btn" onClick={handleSave}>업데이트</button>
                </div>
            </div>
        </div>
    );
};

export default UserEditModal;
